<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="config_list"
      hide-actions
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="text-xs-center">{{ props.item.str_value }}</td>
        <td class="text-xs-center">{{ props.item.int_value }}</td>
        <td>
          <v-select
            :items="config_values"
            v-model="config_change[props.item.id]"
            label="Cambiar configuración"
            @change="changeConfig(props.item.id)"
          ></v-select>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'configurations-view',
    data() {
      return {
        dialog: false,
        headers: [
          { text: 'Configuracion', align: 'center', value: 'description' },
          { text: 'Str Valor', align: 'center', value: 'str_value', sortable: false },
          { text: 'Int Valor', align: 'center', value: 'int_value', sortable: false },
          { text: 'Configuración', align: 'center', value: '', sortable: false, width: '300px' },
        ],
        config_change: {},
        config_list: [],
        config_values: [
          { value: 1, str_value: 'TRUE', text: 'Activo'},
          { value: 0, str_value: 'FALSE', text: 'Inactivo'},
        ]
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/configurations')
          .then(resp => {
            if (resp.status === 200) {
              this.config_list = resp.data
              this.config_change = {}
            }
          })
          .catch(error => console.log(error))
      },
      changeConfig(config_id) {
        const new_value = this.config_change[config_id]
        const new_config = this.config_values.find(config => config.value == new_value)

        axios.put('/api/configuration', { id: config_id, ...new_config })
          .then(resp => {
            if (resp.status === 200) {
              this.init()
            }
          })
          .catch(error => console.log(error))
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/configuration.vue